export const DELETED_ACCOUNT_TAG = "Deleted account"

export const DELETED_ACCOUNT_ACTIONS_TOOLTIP =
  "Actions unavailable: user deleted account"

/**
 * Prefer `is_deleted` from API; if missing, detect placeholder emails used after
 * self-delete (e.g. `deleted_<id>@anon...`).
 */
export function isDeletedAccountRow(record: {
  is_deleted?: boolean
  email?: string | null
}): boolean {
  if (record.is_deleted === true) return true
  const email = (record.email ?? "").trim().toLowerCase()
  if (!email) return false
  return email.startsWith("deleted_")
}

export function applyDisabledForDeletedAccount<
  T extends { disabled?: boolean }
>(items: T[], isDeleted: boolean): T[] {
  if (!isDeleted) return items
  return items.map((item) => ({ ...item, disabled: true }))
}

/**
 * Drop removed users from an assignment picker's value. Their historical rows
 * stay on the record server-side; they are simply no longer assignable, and a
 * removed id has no option to resolve against so it would render as a raw id.
 */
export function excludeDeletedAccounts<
  T extends { is_deleted?: boolean; email?: string | null }
>(items: T[] | null | undefined): T[] | undefined {
  return items?.filter((item) => !isDeletedAccountRow(item))
}
